import React from'react';var initialState={};export default React.createContext(initialState);